import { Box } from '@mui/material';
import * as layout from '@ocodelib/compose-layout';
import { useBehaviorSubject } from '@ocodelib/mui/hooks';
import clsx from 'clsx';
import { ContentTabs } from '../components/ContentTabs';
import { useP5BasicApp } from '../useP5BasicApp';
import { PLUGIN_KEYS, PLUGIN_KIND_CONTENT, PLUGIN_KIND_HIDDEN } from './plugin-keys';

interface Props {
  className?: string;
}

export function LayoutRoot(props: Props) {
  const { className } = props;
  const { appManager } = useP5BasicApp();
  const currentTabKey = useBehaviorSubject(appManager.uiState.currentContentTab$);
  const preview = useBehaviorSubject(appManager.uiState.previewMode$);

  return (
    <Box
      className={clsx('LayoutRoot-root', className)}
      sx={{
        display: 'flex',
        maxHeight: '100dvh',
        height: '100dvh',
        minWidth: 700,
        flexDirection: 'column',
        alignItems: 'stretch',
        bgcolor: '#f1f4f8',
        '& > .LayoutRoot-content': {
          flex: 1,
          width: '100%',
        },
      }}
    >
      {/* 프리뷰모드에서는 Topbar를 감춘다 */}
      {!preview && <layout.PluginSlot plugin={PLUGIN_KEYS.root.topBar} />}

      {/* 프리뷰모드에서는 컨텐트탭을 감춘다 */}
      {!preview && <ContentTabs />}

      <layout.PluginSelectableSlot
        className="LayoutRoot-content"
        pluginKind={PLUGIN_KIND_CONTENT}
        selectedPluginName={currentTabKey ?? ''}
      />
      <layout.PluginsSlot pluginKind={PLUGIN_KIND_HIDDEN} />
    </Box>
  );
}
